/** */
export default function passthroughProps(
  passedProps,
  excludePropTypes,
  { omit = [], force = [] }
) {
  let removeProps = Object.keys(excludePropTypes).reduce((accumulator, key) => {
    const newArray = accumulator;
    newArray[key] = true;
    return newArray;
  }, {});

  removeProps = omit.reduce((accumulator, key) => {
    const newArray = accumulator;
    newArray[key] = false;
    return newArray;
  }, removeProps);

  removeProps = force.reduce((accumulator, key) => {
    const newArray = accumulator;
    newArray[key] = true;
    return newArray;
  }, removeProps);

  return Object.keys(passedProps).reduce((accumulator, key) => {
    const newArray = accumulator;
    if (!removeProps[key]) {
      newArray[key] = passedProps[key];
    }

    return newArray;
  }, {});
}
